// extracted by mini-css-extract-plugin
var _1 = "expandButton--Qp41b";
var _2 = "expandOpen--H5TAT";
export { _1 as "expandButton", _2 as "expandOpen" }
